import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { Link, useNavigate } from 'react-router-dom';
import { format, formatISO, subDays } from 'date-fns';
import { DEFAULT_DATE_FORMATE, DEFAULT_LOCAL_PATH } from '../../constents';
// import Period from '../Schedular/Appointment/period';
// import PeriodSelection from '../Schedular/Appointment/PeriodSelection';
import PatientPrgressReport from '../PatientPrgressReport';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import AddNote from './AddNote';
import ViewPhoneNote from './ViewPhoneNote';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCnotePeriod,
  setNoteProSerch,
  setNoteSerchAllsignopen,
  updateNoteSerch,
} from '../../redux/slices/Notes/counsellingNoteSlice';
import DatePickerCalander from '../../Utilities/DatePickerCalander';

function CounselingNote() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);
  const { notesGrid } = useSelector((store) => store.counsellingNote);
  const { cNotePeriodFilter } = useSelector((store) => store.counsellingNote);
  const navigate = useNavigate();

  const {
    chartSerch,
    patSerch,
    dosSerch,
    tovSerch,
    noteStSerch,
    provId,
    provSignSt,
    coSigner,
    coSignerSt,
    actionSt,
    serviceCode,
    billSt,
    allOpen,
    allSigned,
  } = notesGrid;

  const [allData, setAllData] = useState('');

  const [soapId, setSoapId] = useState(false);
  const [patientId, setPatientId] = useState(false);
  const [appointmentId, setAppointmentId] = useState(false);
  const [patProgViewPopup, setPatProgViewPopup] = useState(false);

  const [selectAll, setSelectAll] = useState(false);
  const [sucPrams, setSucPrams] = useState(false);

  const [markCosigner, setMarkCosigner] = useState(false);
  const [phoneNotePopup, setPhoneNotePopup] = useState({
    status: false,
    soapId: 0,
  });
  const [phoneNoteViewPopup, setPhoneNoteViewPopup] = useState({
    status: false,
    soapId: 0,
  });
  const [visit_id, setVisit_id] = useState(false);

  const handleCounPopUpOpen = (
    soapId,
    patientId,
    appointmentId,
    lable,
    visitId,
  ) => {
    setSoapId(soapId);
    setPatientId(patientId);

    if (lable === 'Access' || lable === 'View & Sign') {
      setPatProgViewPopup(true);
      setVisit_id(visitId);
      setAppointmentId(appointmentId);
    } else if (lable === 'Record') {
      navigate(
        `${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}/${appointmentId}`,
        {
          replace: true,
        },
      );
    }
  };

  const [reload, setReload] = useState(false);
  function handleReload() {
    setReload(!reload);
  }

  useEffect(() => {
    if (user?.id && user?.is_supervisor !== '1') {
      dispatch(setNoteProSerch(user?.id));
    } else {
      dispatch(setNoteProSerch(''));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (cNotePeriodFilter.startDate) {
      (async () => {
        try {
          const response = await post(
            'api/notes/ProgressNote/allCounselingNoteList',
            {
              filterDate: `${format(
                new Date(cNotePeriodFilter.startDate),
                'yyyy-MM-dd',
              )}|${format(new Date(cNotePeriodFilter.endDate), 'yyyy-MM-dd')}`,
              dos: dosSerch,
              tov: tovSerch,
              noteSt: noteStSerch,
              provId: provId,
              provSignSt: provSignSt,
              coSigner: coSigner,
              coSignerSt: coSignerSt,
              actionSt: actionSt,
              serviceCode: serviceCode,
              billSt: billSt,
              chartNo: chartSerch,
              patientName: patSerch,
              staffUserId: user?.id,
              allOpen: allOpen,
              allSigned: allSigned,
            },
          );
          if (response.status === 200) {
            setAllData(response?.data);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })();
    }
  }, [
    chartSerch,
    patSerch,
    dosSerch,
    tovSerch,
    noteStSerch,
    provId,
    provSignSt,
    coSigner,
    coSignerSt,
    actionSt,
    serviceCode,
    billSt,
    cNotePeriodFilter,
    reload,
    user?.id,
    globalReload,
    allOpen,
    allSigned,
  ]);

  useEffect(() => {
    if (allOpen === 0 && allSigned === 0) {
      dispatch(setNoteSerchAllsignopen(1));
    }
  }, [allOpen, allSigned, dispatch]);

  const handleRowSelect = (index) => {
    const updatedRows = [...allData?.counNote];
    updatedRows[index].selected = !updatedRows[index].selected;
    setAllData({ ...allData, counNote: updatedRows });
  };

  const handleSelectAll = () => {
    if (allData?.counNote) {
      const updatedRows = allData?.counNote.map((row) => ({
        ...row,
        selected: !selectAll,
      }));
      setAllData({ ...allData, counNote: updatedRows });
      setSelectAll(!selectAll);
    }
  };

  useEffect(() => {
    if (allData?.counNote) {
      const allRowsSelected = allData?.counNote?.every((row) => row.selected);
      setSelectAll(allRowsSelected);
    }
  }, [allData?.counNote]);

  const handleAsignSuperviser = (e) => {
    const superId = e.target.value;
    const seltRowSoapId =
      allData?.counNote &&
      allData?.counNote.reduce((acc, data, i) => {
        if (data?.selected) {
          acc.push(data?.soapId);
        }
        return acc;
      }, []);

    const selectedIndex = e.target.selectedIndex;
    const selectedText = e.target.options[selectedIndex].text;
    if (superId) {
      if (seltRowSoapId.length <= 0) {
        setUiMessage(
          'err',
          'Please select the note from the checkbox & then select co-signer from this dropdown.',
        );
      } else {
        setSucPrams([superId, seltRowSoapId.join(',')]);
        if (superId === 'notApp') {
          setMarkCosigner(
            `Are you sure want to assign checked note as (Not Applicable) for Co-Assignee?`,
          );
        } else {
          setMarkCosigner(
            `Do you want to assign this Co-Assign provider (<b>${selectedText}</b>) for below checked record ?`,
          );
        }
      }
    }
  };

  const handleAsignSuperviserConfirm = async (args) => {
    const providerId = args[0];
    const soapIds = args[1];

    if ((providerId, soapIds)) {
      const response = await post(
        'api/notes/ProgressNote/assignCoAssignProvider',
        {
          coAssignId: providerId,
          checkedRecord: soapIds,
          loginUserId: user?.id,
        },
      );
      if (response.status === 200) {
        setMarkCosigner(false);
        setUiMessage('suc', 'Co-Assign has been assigned to Selected record.');
        handleReload();
      }
    }
  };

  const handlePhoneNoteAccess = (id, patId) => {
    setPhoneNoteViewPopup({ status: true, soapId: id, patId: patId });
  };
  const handlePhoneNoteChange = (id, patId) => {
    setPhoneNotePopup({ status: true, soapId: id, patId: patId });
  };

  const handleDateFilter = (days, filterName) => {
    const date = new Date();
    const newDate = subDays(date, days);
    dispatch(
      setCnotePeriod({
        name: filterName,
        startDate: formatISO(newDate),
        endDate: formatISO(date),
      }),
    );
  };

  return (
    <main>
      <section>
        <div className="child-menu-body">
          <div className="bnc-mn-hdr">
            <div className="bill-dt-main-con">
              <div className="bill-days-blk">
                <span className="intake-head-inpt-main">
                  <span className="intake-head-hedding">Display:</span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(90, '90D')}
                      checked={cNotePeriodFilter?.name === '90D' ? true : false}
                    />
                    <span className="">90 days</span>
                  </span>

                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(60, '60D')}
                      checked={cNotePeriodFilter?.name === '60D' ? true : false}
                    />
                    <span className="">60 days</span>
                  </span>

                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(30, '30D')}
                      checked={cNotePeriodFilter?.name === '30D' ? true : false}
                    />
                    <span className="">30 days</span>
                  </span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => handleDateFilter(7, '7D')}
                      checked={cNotePeriodFilter?.name === '7D' ? true : false}
                    />
                    <span className="">7 days</span>
                  </span>
                  <span className="intake-head-inpt-sec">
                    <input
                      type="radio"
                      name="radio2"
                      onChange={() => {
                        dispatch(
                          setCnotePeriod({
                            name: 'Today',
                            startDate: formatISO(new Date()),
                            endDate: formatISO(new Date()),
                          }),
                        );
                      }}
                      checked={
                        cNotePeriodFilter?.name === 'Today' ? true : false
                      }
                    />
                    <span className="">Today</span>
                  </span>

                  <div className="intake-serch-calander-sec">
                    <span className="intake-head-inpt-sec">
                      <input
                        type="radio"
                        name="radio2"
                        onChange={() => {
                          dispatch(
                            setCnotePeriod({
                              name: 'DR',
                              startDate: null,
                              endDate: formatISO(new Date()),
                            }),
                          );
                        }}
                        checked={
                          cNotePeriodFilter?.name === 'DR' ? true : false
                        }
                      />
                    </span>
                    <span className="intake-serch-calander">
                      <DatePickerCalander
                        selectedDate={
                          cNotePeriodFilter?.startDate
                            ? new Date(cNotePeriodFilter?.startDate)
                            : null
                        }
                        setSelectedDate={(date) => {
                          if (date) {
                            dispatch(
                              setCnotePeriod({
                                name: 'DR',
                                startDate: formatISO(date),
                                endDate: cNotePeriodFilter?.endDate,
                              }),
                            );
                          }
                        }}
                        className="add-task-date-picker"
                        style={{
                          width: '75px',
                        }}
                        dateFormat={DEFAULT_DATE_FORMATE}
                        maxDate={
                          cNotePeriodFilter?.endDate
                            ? new Date(cNotePeriodFilter?.endDate)
                            : new Date()
                        }
                        editFlag={cNotePeriodFilter?.name !== 'DR'}
                      />
                    </span>
                    <span className="date-sep-blu-hdr">-</span>
                    <span className="intake-serch-calander">
                      <DatePickerCalander
                        selectedDate={
                          new Date(cNotePeriodFilter?.endDate) || new Date()
                        }
                        setSelectedDate={(date) => {
                          if (date) {
                            dispatch(
                              setCnotePeriod({
                                name: 'DR',
                                startDate: cNotePeriodFilter?.startDate,
                                endDate: formatISO(date),
                              }),
                            );
                          }
                        }}
                        className="add-task-date-picker"
                        style={{
                          width: '75px',
                        }}
                        dateFormat={DEFAULT_DATE_FORMATE}
                        minDate={
                          cNotePeriodFilter?.startDate
                            ? new Date(cNotePeriodFilter?.startDate)
                            : null
                        }
                        editFlag={cNotePeriodFilter?.name !== 'DR'}
                      />
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div className="child-body-rw appt-sec-fst-rw">
            {/* <div className="appt-d-display">
              <Period
                periodFilter={cNotePeriodFilter}
                setPeriodFilter={(obj) => dispatch(setCnotePeriod(obj))}
              />
              <PeriodSelection
                selectedPeriod={cNotePeriodFilter}
                setPeriodFilter={(obj) => dispatch(setCnotePeriod(obj))}
              />
            </div> */}
            <div
              className="child-body-rw appt-sec-fst-new nots-scrn"
              style={{ display: 'unset', margin: '0px' }}
            >
              <div
                className="appt-loc-val"
                style={{
                  display: 'flex',
                  width: '100%',
                  margin: '0px',
                  fontWeight: 'bold',
                }}
              >
                <div
                  // className="appt-loc-val"
                  style={{
                    flexBasis: '45%',
                    margin: '0px',
                    textAlign: 'right',
                  }}
                >
                  <input
                    type="radio"
                    className=""
                    value={allOpen}
                    checked={allOpen === 1 && allSigned === 0}
                    onChange={(e) => {
                      dispatch(
                        updateNoteSerch({
                          key: 'allOpen',
                          value: e.target.checked ? 1 : 0,
                        }),
                      );
                      dispatch(
                        updateNoteSerch({
                          key: 'allSigned',
                          value: e.target.checked ? 0 : 1,
                        }),
                      );
                    }}
                  />
                  <span className="clear-left10">Open</span>
                </div>
                <div
                  // className="appt-loc-val"
                  style={{
                    flexBasis: 'unset',
                    margin: '0px 0px 0px 5%',
                    textAlign: 'left',
                  }}
                >
                  <input
                    type="radio"
                    className=""
                    value={allSigned}
                    checked={allSigned === 1 && allOpen === 0}
                    onChange={(e) => {
                      dispatch(
                        updateNoteSerch({
                          key: 'allSigned',
                          value: e.target.checked ? 1 : 0,
                        }),
                      );
                      dispatch(
                        updateNoteSerch({
                          key: 'allOpen',
                          value: e.target.checked ? 0 : 1,
                        }),
                      );
                    }}
                  />
                  <span className="clear-left10">Signed</span>
                </div>
                <div
                  // className="appt-loc-val"
                  style={{
                    flexBasis: 'unset',
                    margin: '0px 0px 0px 5%',
                    textAlign: 'left',
                  }}
                >
                  <input
                    type="radio"
                    className=""
                    checked={allSigned && allOpen}
                    onChange={(e) => {
                      dispatch(
                        updateNoteSerch({
                          key: 'allSigned',
                          value: e.target.checked ? 1 : 0,
                        }),
                      );
                      dispatch(
                        updateNoteSerch({
                          key: 'allOpen',
                          value: e.target.checked ? 1 : 0,
                        }),
                      );
                    }}
                  />
                  <span className="clear-left10">ALL</span>
                </div>
              </div>

              <div className="left width100 flex-sec">
                <div className="appt-loc-val">
                  <span className="red fontsize20">&#9632;</span>{' '}
                  {allData?.pendingNote} notes pending to Record
                </div>
                <div className="appt-loc-val">
                  <span className="orange-txt fontsize20">&#9632;</span>{' '}
                  {allData?.pendingSignNote} notes pending Signature
                </div>
                <div className="appt-loc-val">
                  <span className="purple fontsize20">&#9632;</span>{' '}
                  {allData?.pendingReview} notes pending Review & Co-signature
                </div>
              </div>
              <div className="appt-search">
                <span className="appt-loc-val hide">
                  <span className="prnt-btn">Export excel</span>
                </span>
              </div>
            </div>
          </div>

          <div className="c-mid-bdy-blk">
            <div className="t-plan-hdr notes-main-screen">
              <span className="t-plan-lbl ns-col-0">
                <span className="">
                  <input
                    type="checkbox"
                    className=""
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </span>
                <span className="">
                  <select
                    className="appt-col-slct clear-left10"
                    onChange={(e) => handleAsignSuperviser(e)}
                  >
                    <option value="">Assign supervisor</option>
                    {allData?.allResource &&
                      allData?.allResource.map((note, idx) => {
                        return (
                          <option key={idx} value={note?.id}>
                            {note?.resName}
                          </option>
                        );
                      })}
                    <option value="notApp">Not Applicable</option>
                  </select>
                </span>
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Chart#</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="search chart#..."
                  value={chartSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'chartSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">Patient</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="search patient..."
                  value={patSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'patSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2">
                <span className="bold">DOS</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="mm-dd-yyyy"
                  value={dosSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'dosSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Visit Type.</span>
                <select
                  className="appt-col-slct"
                  value={tovSerch || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'tovSerch',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.allTov &&
                    allData?.allTov.map((visitVal, idx) => {
                      return (
                        <option key={idx} value={visitVal?.id}>
                          {visitVal?.visit_type}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Action</span>
                <select
                  className="appt-col-slct"
                  value={actionSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'actionSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.actionFilter &&
                    allData?.actionFilter.map((filter, idx) => {
                      return (
                        <option key={idx} value={filter?.id}>
                          {filter?.val}
                        </option>
                      );
                    })}
                </select>
              </span>

              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Provider</span>
                <select
                  className="appt-col-slct"
                  value={provId || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'provId',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.allResource &&
                    allData?.allResource.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.resName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Provider Sign.</span>
                <select
                  className="appt-col-slct"
                  value={provSignSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'provSignSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.signStatus &&
                    allData?.signStatus.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Co-Signer</span>
                <select
                  className="appt-col-slct"
                  value={coSigner || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'coSigner',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.allResource &&
                    allData?.allResource.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.resName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-4">
                <span className="bold">Co-Signer Sign.</span>
                <select
                  className="appt-col-slct"
                  value={coSignerSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'coSignerSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.signStatus &&
                    allData?.signStatus.map((note, idx) => {
                      return (
                        <option key={idx} value={note?.id}>
                          {note?.val}
                        </option>
                      );
                    })}
                </select>
              </span>

              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Payor</span>
                <select className="appt-col-slct">
                  <option value="">All Payor</option>
                  {allData?.allInsurance &&
                    allData?.allInsurance.map((ins, idx) => {
                      return (
                        <option key={idx} value={ins?.id}>
                          {ins?.insName}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Service Code</span>
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Service Code..."
                  value={serviceCode || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'serviceCode',
                        value: e.target.value,
                      }),
                    )
                  }
                />
              </span>
              <span className="t-plan-lbl pc-col-2 bold">Dx</span>

              <span className="t-plan-lbl pc-col-1">
                <span className="bold">Billing</span>
                <select
                  className="appt-col-slct"
                  value={billSt || ''}
                  onChange={(e) =>
                    dispatch(
                      updateNoteSerch({
                        key: 'billSt',
                        value: e.target.value,
                      }),
                    )
                  }
                >
                  <option value="">All</option>
                  {allData?.billStatus &&
                    allData?.billStatus.map((bill, idx) => {
                      return (
                        <option key={idx} value={bill?.id}>
                          {bill?.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="t-plan-lbl pc-col-2 bold">$</span>
            </div>
            {allData?.counNote && allData?.counNote.length > 0 ? (
              <div className="t-plan-bdy notes-main-screen">
                {allData?.counNote.map((item, idx) => {
                  const ltClass = idx % 2 === 0 ? '' : 'alt-rw';
                  return (
                    <div key={idx} className={`t-plan-bdy-rw ${ltClass}`}>
                      <span className="t-plan-lbl ns-col-0">
                        <input
                          type="checkbox"
                          className=""
                          checked={item?.selected ? true : false}
                          onChange={() => handleRowSelect(idx)}
                        />
                      </span>
                      <span className="t-plan-lbl pc-col-2 caps">
                        {item?.chartNo}
                      </span>
                      <span className="t-plan-lbl pc-col-2">
                        <Link
                          to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.user_id}`}
                        >
                          {item?.patientName}
                        </Link>
                      </span>
                      <span className="t-plan-lbl pc-col-2">{item?.dos}</span>
                      <span className="t-plan-lbl pc-col-4">{item?.tov}</span>
                      <span className="t-plan-lbl pc-col-1">
                        {item?.tov === 'Phone Note' ||
                        item?.tov === 'Discharge Note' ||
                        item?.tov === 'Clinical Note' ? (
                          <>
                            <span
                              onClick={() =>
                                handlePhoneNoteAccess(
                                  item?.soapId,
                                  item?.user_id,
                                )
                              }
                            >
                              <Link>Access</Link>
                            </span>{' '}
                            |{' '}
                            <span
                              onClick={() =>
                                handlePhoneNoteChange(
                                  item?.soapId,
                                  item?.user_id,
                                )
                              }
                            >
                              <Link>Change</Link>
                            </span>
                          </>
                        ) : (
                          <span
                            className=""
                            onClick={() =>
                              handleCounPopUpOpen(
                                item?.soapId,
                                item?.user_id,
                                item?.appointmentId,
                                item?.actionLabel,
                                item?.visitId,
                              )
                            }
                          >
                            <Link>{item?.actionLabel}</Link>
                          </span>
                        )}
                      </span>
                      <span className="t-plan-lbl pc-col-1">
                        {item?.providerName}
                      </span>
                      <span className="t-plan-lbl pc-col-4 qmaroon">
                        {item?.signSt}
                      </span>
                      <span className="t-plan-lbl pc-col-1">
                        {/* {item?.coSigner} */}
                        {item?.providerName === item?.coSigner
                          ? ''
                          : item?.coSigner}
                      </span>
                      <span className="t-plan-lbl pc-col-4 maroon ">
                        {/* {item?.coSignSt} */}
                        {item?.providerName === item?.coSigner
                          ? ''
                          : item?.coSignSt}
                      </span>
                      {/* <span className="t-plan-lbl pc-col-2 maroon">
                        {item?.noteSt}
                      </span> */}

                      <span className="t-plan-lbl pc-col-1">{item?.payor}</span>
                      <span className="t-plan-lbl pc-col-1">
                        {item?.serviceCode}
                      </span>
                      <span className="t-plan-lbl pc-col-2">{item?.dx}</span>
                      <span className="t-plan-lbl pc-col-1">
                        {item?.billingSt}
                      </span>
                      <span className="t-plan-lbl pc-col-2">{item?.amt}</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="no-appoinmnts-here">No Pt. Information !!</p>
            )}
          </div>
        </div>
        {patProgViewPopup && (
          <PatientPrgressReport
            soapId={soapId}
            patientId={patientId}
            appId={appointmentId}
            visit_id={visit_id}
            close={() => setPatProgViewPopup(false)}
            handleReload={handleReload}
          />
        )}
        {markCosigner && (
          <ConfirmDialog
            title={'Confirm'}
            bodytext={
              <div dangerouslySetInnerHTML={{ __html: markCosigner }} />
            }
            closeDialog={() => setMarkCosigner(false)}
            successDialog={handleAsignSuperviserConfirm}
            sucPrams={sucPrams}
          />
        )}
        {phoneNotePopup.status && (
          <AddNote
            patId={phoneNotePopup?.patId}
            soapId={phoneNotePopup?.soapId}
            handleClose={() =>
              setPhoneNotePopup({ ...phoneNotePopup, status: false })
            }
          />
        )}
        {phoneNoteViewPopup.status && (
          <ViewPhoneNote
            patId={phoneNoteViewPopup?.patId}
            soapId={phoneNoteViewPopup?.soapId}
            handleClose={() =>
              setPhoneNoteViewPopup({ ...phoneNoteViewPopup, status: false })
            }
            handleChange={() => {
              setPhoneNoteViewPopup({ ...phoneNoteViewPopup, status: false });
              handlePhoneNoteChange(
                phoneNoteViewPopup?.soapId,
                phoneNoteViewPopup?.patId,
              );
            }}
          />
        )}
      </section>
    </main>
  );
}

export default CounselingNote;
